import React, { createContext, useContext, useMemo, useState, } from 'react';
import { isNil } from 'ramda';
import { useGetAdhocMessages } from '@/platform-services/adhoc-message';
const AdhocMessageContext = createContext({
    adhocMessages: [],
    dismissAdhocMessage: () => { },
});
const ADHOC_MESSAGES_KEY = 'gbi:message';
export const loadDismissedMessageIdsFromLocalStorage = () => {
    const dismissedMessageIdsStr = localStorage.getItem(ADHOC_MESSAGES_KEY);
    if (isNil(dismissedMessageIdsStr)) {
        return [];
    }
    try {
        const dismissedMessageIds = JSON.parse(dismissedMessageIdsStr);
        return dismissedMessageIds;
    }
    catch (_a) {
        return [];
    }
};
export const saveDismissedMessageIdsToLocalStorage = (dismissedMessageIds) => {
    localStorage.setItem(ADHOC_MESSAGES_KEY, JSON.stringify(dismissedMessageIds));
};
export const AdhocMessageProvider = ({ children }) => {
    const { data: fetchedMessages } = useGetAdhocMessages();
    const [dismissedMessageIds, setDismissedMessageIds] = useState(loadDismissedMessageIdsFromLocalStorage());
    const adhocMessages = useMemo(() => {
        if (!fetchedMessages)
            return [];
        return fetchedMessages.filter((msg) => !dismissedMessageIds.includes(msg.id));
    }, [fetchedMessages, dismissedMessageIds]);
    const dismissAdhocMessage = (adhocMessageToRemove) => {
        const updatedDismissedMessageIds = [...dismissedMessageIds, adhocMessageToRemove.id];
        setDismissedMessageIds(updatedDismissedMessageIds);
        saveDismissedMessageIdsToLocalStorage(updatedDismissedMessageIds);
    };
    return (<AdhocMessageContext.Provider value={{
            adhocMessages,
            dismissAdhocMessage,
        }}>
      {children}
    </AdhocMessageContext.Provider>);
};
export const useAdhocMessages = () => useContext(AdhocMessageContext);
